module.exports = __webpack_public_path__ + "img/EBSoftware4.149acec5.png";